
module.exports = require('./lib/index');



//////////////////
// WEBPACK FOOTER
// ./~/engine.io-client/index.js
// module id = 1194
// module chunks = 13